var _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveDragonTiger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 32 C10 24 6 18 12 12 C14 18 12 20 16 20 C14 16 18 10 22 8 C22 14 20 16 24 18 C26 14 28 10 32 8 C30 16 26 20 28 26 C24 22 22 28 20 32 C18 26 14 28 8 32Z",
    fill: "#f97316",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32 C14 26 10 22 14 16 C16 20 14 22 18 24 C16 20 20 14 24 12 C22 18 24 22 28 24 C26 22 28 26 20 32 C18 28 14 30 12 32Z",
    fill: "#fbbf24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2,
    fill: "#ef4444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 1.5,
    fill: "#ef4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDragonTiger);
export default __webpack_public_path__ + "static/media/live-dragon-tiger.7e5e7b0bfd0a49f67eaed4c573f91e37.svg";
export { ForwardRef as ReactComponent };